import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject;
import { css } from 'styled-components';
var height = s => {
  switch (s) {
    case 'large':
      return 36;
    case 'normal':
      return 32;
    case 'small':
      return 28;
    case 'extra-small':
      return 24;
    case 'double-extra-small':
      return 20;
    default:
      return 32;
  }
};
export var _CSS_SIZE_HEIGHT = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  height: ", "px;\n"])), p => height(p.size));
_CSS_SIZE_HEIGHT.height = height;
export var CSS_SIZE_HEIGHT = _CSS_SIZE_HEIGHT;
//# sourceMappingURL=size-height.js.map